import { Component } from 'react';
import { observable, action, makeObservable, runInAction } from 'mobx';
import { observer } from 'mobx-react';
import apiService from '@services/apiService';
import { ImgForward } from '@components/Images/ImgForward';

type FollowUpSuggestionsProps = {
  chatId: string;
  modelName: string;
  serverKey: string;
  onSelect: (suggestion: string) => void;
};

@observer
export default class FollowUpSuggestions extends Component<FollowUpSuggestionsProps> {

  @observable private _suggestions: string[] = [];
  @observable private _isLoading: boolean = false;
  @observable private _hasError: boolean = false;

  constructor(props: FollowUpSuggestionsProps) {
    super(props);
    makeObservable(this);
  }

  componentDidMount(): void {
    void this._loadFollowUps();
  }

  componentDidUpdate(prevProps: FollowUpSuggestionsProps): void {
    if (prevProps.chatId !== this.props.chatId) {
      this._suggestions = [];
      void this._loadFollowUps();
    }
  }

  render() {
    if (this._hasError || (!this._isLoading && !this._suggestions.length)) {
      return null;
    }

    return (
      <div className="follow-up-suggestions">
        {this._isLoading && (
          <div className="follow-up-loading">
            <span className="follow-up-loading-dot"></span>
            <span className="follow-up-loading-dot"></span>
            <span className="follow-up-loading-dot"></span>
          </div>
        )}
        {!this._isLoading && this._suggestions.map((suggestion, index) => (
          <button
            key={index}
            className="follow-up-btn"
            onClick={() => this.props.onSelect(suggestion)}
          >
            <span className="follow-up-arrow"><ImgForward size={14}/></span>
            {suggestion}
          </button>
        ))}
      </div>
    );
  }

  @action
  private async _loadFollowUps() {
    const { chatId, modelName, serverKey } = this.props;
    if (!chatId || !modelName) return;

    this._isLoading = true;
    this._hasError = false;

    try {
      const result = await apiService.post<{ suggestions: string[] }>(
        `/api/chats/${chatId}/follow-ups`,
        { model: modelName },
        {
          headers: {
            'x-ollama-server': serverKey,
          }
        }
      );

      runInAction(() => {
        this._suggestions = result?.suggestions || [];
        this._isLoading = false;
      });
    } catch {
      runInAction(() => {
        this._isLoading = false;
        this._hasError = true;
      });
    }
  }
}
